export const QUICKSTART_UI_STATUS_NOT_LOADED = Symbol('NOT_LOADED');
export const QUICKSTART_UI_STATUS_OPEN = Symbol('OPEN');
export const QUICKSTART_UI_STATUS_MINIMIZED = Symbol('MINIMIZED');
export const QUICKSTART_UI_STATUS_DISMISSED = Symbol('DISMISSED');

export const QUICKSTART_PANEL_ID = 'jpd-quickstart';
export const QUICKSTART_PANEL_WIDTH = 365;
export const QUICKSTART_PANEL_VISIBILITY_STATE_KEY = 'polaris.quickstart-panel-visibility-state';

export type QuickstartUiStatus =
	| typeof QUICKSTART_UI_STATUS_NOT_LOADED
	| typeof QUICKSTART_UI_STATUS_OPEN
	| typeof QUICKSTART_UI_STATUS_MINIMIZED
	| typeof QUICKSTART_UI_STATUS_DISMISSED;

export const DEFAULT_QUICKSTART_UI_STATUS: QuickstartUiStatus = QUICKSTART_UI_STATUS_OPEN;
